import gql from 'graphql-tag';

export const updateAdmin = gql`
  mutation updateAdmin($input: updateAdminInput!){
    updateAdmin(input: $input){
      id
    }
  }
`;
